import { render } from "./SlideOfficerSearch.vue?vue&type=template&id=32bc84da&scoped=true"
import script from "./SlideOfficerSearch.vue?vue&type=script&lang=js"
export * from "./SlideOfficerSearch.vue?vue&type=script&lang=js"

import "./SlideOfficerSearch.vue?vue&type=style&index=0&id=32bc84da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bc84da"]])

export default __exports__